import { Container } from './styles';

const Spinner = () => (
  <Container viewBox="0 0 50 50">
    <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
  </Container>
);

export default Spinner;
